/**
 * Do not edit directly
 * Generated on Thu, 29 Sep 2022 18:15:25 GMT
 */

export const componentFormHelperTextAliasName = "component.text.caption";
export const componentFormHelperTextStateDisabledTextColor = "#babbbe";
export const componentFormHelperTextStateErrorTextColor = "#de1c24";
export const componentFormHelperTextTextColor = "#74767c";
export const componentFormHelperTextIconStateDisabledIconColor = "#babbbe";
export const componentFormHelperTextIconStateErrorIconColor = "#de1c24";
export const componentFormHelperTextIconStateErrorIconName = "InfoCircle";
export const componentFormHelperTextIconStateErrorIconSize = "small";
export const componentFormHelperTextIconStateErrorMarginRight = "0.25rem";
export const componentFormLabelSizeLargeAliasName = "component.text.body";
export const componentFormLabelSizeLargeAliasOptionsSize = "small";
export const componentFormLabelSizeLargeAliasOptionsWeight = 700;
export const componentFormLabelSizeSmallAliasName = "component.text.caption";
export const componentFormLabelSizeSmallAliasOptionsWeight = 700;
export const componentFormLabelStateDisabledTextColor = "#babbbe";
export const componentFormLabelTextColor = "#2e2f32";